module.exports = __webpack_public_path__ + "media/images/creativeCampaign-72c03011e697577c277d162d3a969854460507152210c5daa6034303abc86f3e.svg";